import { SavedSearchFilter } from '@creditsights/api-ui-web';
import { Tooltip } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { useRef } from 'react';
import styles from './FiltersRenderer.module.scss';

const cx = classNames.bind(styles);

interface FormattedFilterProps {
  filter: SavedSearchFilter;
}

const renderFilterDisplayValue = (filter: SavedSearchFilter) =>
  filter.tags.map((tag, i) => (
    <span key={tag.tagId} data-testid="tag">
      {i > 0 && filter.tags.length && <span className={cx('junction')}> OR </span>}
      {tag.name}
    </span>
  ));

const FormattedFilter = ({ filter }: FormattedFilterProps): React.ReactElement => {
  const filterRef = useRef<HTMLDivElement>(null);
  const isOverflowing = filterRef.current && filterRef.current.scrollWidth > filterRef.current.offsetWidth;
  const displayValue = renderFilterDisplayValue(filter);

  return (
    <Tooltip disabled={!isOverflowing} content={displayValue}>
      <div className={cx('filter')} data-testid="filter" ref={filterRef}>
        {displayValue}
      </div>
    </Tooltip>
  );
};

export default FormattedFilter;
